import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';

import CircleIcon from './icons/circle_icon';

export default class ConferenceButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <g id="iconConference">
          <path d="M8.194 17.204s-.14-4.1 5.036-4.1c5.178 0 5.13 4.1 5.13 4.1H8.194zM15.874 9.846c0 1.435-1.163 2.597-2.597 2.597S10.68 11.28 10.68 9.846c0-1.434 1.163-2.596 2.597-2.596s2.597 1.162 2.597 2.596" />
          <path d="M8.215 12.152v-1.667H6.548v-.477h1.667V8.342h.476v1.666h1.668v.477H8.69v1.667" />
        </g>
      </CircleIcon>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/buttons/conference_button.jsx